<template>
  <div>
    <div class="reset-password-form">
      <div class="acc-email">{{ emailToRead }}</div>
      <div class="form-group" :class="{ 'has-error': validation.hasError('password') }">
        <div class="input-group">
          <input
            type="password"
            v-focus
            name="password"
            v-model="password"
            @keypress.enter="setNewPassword"
            placeholder="New Password..."
            class="form-control input-lg"
          />
          <span class="input-group-btn">
            <button class="btn btn-lg btn-primary btn-block" :disabled="!password" @click="setNewPassword()">
              <digital-event-preloader type="container" :active="isLoading" />
              <i class="fa fa-fw fa-lg fa-arrow-right"></i>
            </button>
          </span>
        </div>
        <div v-if="!validation.firstError('password')" class="password-min">
          <i class="fa fa-key" aria-hidden="true"></i> minimum: 8 characters 1 number 1 uppercase
        </div>
        <div v-else class="form-field-error-message">{{ validation.firstError("password") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthMixin from "./mixins/AuthMixin";
import SetPasswordMixin from "./mixins/SetPasswordMixin";
import { mapGetters } from "vuex";

export default {
  name: "SetNewPassword",
  mixins: [AuthMixin, SetPasswordMixin],
  computed: {
    ...mapGetters(["isLoading"])
  }
};
</script>
